// extracted by mini-css-extract-plugin
export default {"icon":"CartProductCard_icon__ttiIo","disabled":"CartProductCard_disabled__5qVdD"};